import { c as _c } from "react/compiler-runtime";
import { HTMLAttributes, ReactNode } from 'react';
import styles from './Dropdown.module.css';
interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  ariaLabel: string;
  friKomponent: boolean;
  erApen: boolean;
}
const Dropdown = t0 => {
  const $ = _c(12);
  let ariaLabel;
  let children;
  let divProperties;
  let erApen;
  let friKomponent;
  if ($[0] !== t0) {
    ({
      erApen,
      ariaLabel,
      friKomponent,
      children,
      ...divProperties
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = children;
    $[3] = divProperties;
    $[4] = erApen;
    $[5] = friKomponent;
  } else {
    ariaLabel = $[1];
    children = $[2];
    divProperties = $[3];
    erApen = $[4];
    friKomponent = $[5];
  }
  let t1;
  if ($[6] !== ariaLabel || $[7] !== children || $[8] !== divProperties || $[9] !== erApen || $[10] !== friKomponent) {
    t1 = erApen ? <div role="dialog" aria-modal="true" aria-label={ariaLabel} className={`${styles.panel} ${friKomponent ? styles.panelFriKomponent : ""}`} {...divProperties}>{children}</div> : null;
    $[6] = ariaLabel;
    $[7] = children;
    $[8] = divProperties;
    $[9] = erApen;
    $[10] = friKomponent;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
};
export default Dropdown;